export const InsertText = 'insertText'
